import { render, staticRenderFns } from "./LightboxBeforeAfterCard.vue?vue&type=template&id=1ae43082&scoped=true&"
import script from "./LightboxBeforeAfterCard.vue?vue&type=script&lang=js&"
export * from "./LightboxBeforeAfterCard.vue?vue&type=script&lang=js&"
import style0 from "./LightboxBeforeAfterCard.vue?vue&type=style&index=0&id=1ae43082&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae43082",
  null
  
)

export default component.exports